import { boronClient } from "../../../../api";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";
import { useRemoveKarteCommentCache } from "../../../../hooks/http/useFetchKarte";
import { useUpdateSectionKartesCache } from "../../../../hooks/http/useFetchSectionKartes";
import { useUpdateStudentKartesCache } from "../../../../hooks/http/useFetchStudentKartes";

interface Props {
  sectionId: string;
  studentId: string;
  karteId: string;
  commentId: string;
}

export const useDeleteKarteComment = ({
  sectionId,
  studentId,
  karteId,
  commentId,
}: Props) => {
  const { removeKarteCommentCache } = useRemoveKarteCommentCache({
    studentId,
    karteId,
  });

  const { removeKarteCommentCache: removeSectionKarteCommentCache } =
    useUpdateSectionKartesCache();
  const { removeKarteCommentCache: removeStudentKarteCommentCache } =
    useUpdateStudentKartesCache();

  return useBoronMutation(
    async () =>
      await boronClient.DELETE(
        "/api/v1/students/{student_id}/kartes/{karte_hashid}/comments/{karte_comment_hashid}",
        {
          params: {
            path: {
              student_id: studentId,
              karte_hashid: karteId,
              karte_comment_hashid: commentId,
            },
          },
        },
      ),
    {
      onSuccess: () => {
        // 個別カルテキャッシュのコメントを削除
        removeKarteCommentCache(commentId);
        // 校舎カルテ一覧キャッシュのコメントを削除
        removeSectionKarteCommentCache(sectionId, karteId, commentId);
        // 生徒カルテ一覧キャッシュのコメントを削除
        removeStudentKarteCommentCache(studentId, karteId, commentId);
      },
    },
  );
};
